import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getLink = async (id) => {
  const response = await axios.get(routes.inviteflowGetLink(id), AXIOS_DEFAULT_CONFIG);
  return response;
};

export default getLink;
